import { render, staticRenderFns } from "./CampaignAddCustomer.vue?vue&type=template&id=5de4b0b3&scoped=true&"
import script from "./CampaignAddCustomer.vue?vue&type=script&lang=js&"
export * from "./CampaignAddCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CampaignAddCustomer.vue?vue&type=style&index=0&id=5de4b0b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de4b0b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VForm,
  VIcon,
  VTextField,
  VTooltip,
})
